/**
 * Created by matheusmorett on 29/08/18.
 */
import ForgotPassword from './ForgotPassword';
export default ForgotPassword;